import { JobStatus } from "@/models/etc/types";
import { getCurrentLocalDateTime } from "@/utils/auxfunc";

// Признак просрочки у завершённой работы бэк не отдаёт: поле Lost выставляется
// и для «в работе и просрочена», и для «завершена с опозданием», а Status после
// завершения всегда становится Completed. Поэтому для завершённых работ просрочку
// считаем сами, сравнивая CompletionDate со сроком.
export type JobDeadlineState = 'lost' | 'success' | 'neutral'

export type JobDeadlineInput = {
    Status: number
    ToDoDate?: string | Date | null
    CompletionDate?: string | Date | null
}

// Срок работник видит как дату без времени, поэтому и сравниваем по календарным
// дням: работа просрочена, если завершена хотя бы на день позже срока.
const startOfLocalDay = (date: string | Date): number => {
    const dateObj = typeof date === "string" ? new Date(date) : date
    return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()).getTime()
}

export const isSameLocalDay = (a: Date, b: Date): boolean => startOfLocalDay(a) === startOfLocalDay(b)

// Срок хранится в местном времени, но сервер может дописать к нему Z — суффикс пояса отбрасываем
export function parseJobDeadline(value: string | Date | null | undefined): Date | null {
    if (!value) {
        return null
    }
    const date = typeof value === "string"
        ? new Date(value.replace(/(Z|[+-]\d{2}:?\d{2})$/i, ""))
        : value
    return Number.isNaN(date.getTime()) ? null : date
}

// На выбранный день ставится время time (по умолчанию — момент сохранения), без перевода в UTC
export function serializeJobDeadline(day: Date, time: Date = new Date()): string {
    const result = new Date(day)
    result.setHours(time.getHours(), time.getMinutes(), time.getSeconds(), 0)
    return getCurrentLocalDateTime(result)
}

export function isCompletedLate(job: JobDeadlineInput): boolean {
    const toDoDate = parseJobDeadline(job.ToDoDate)
    if (!job.CompletionDate || !toDoDate) {
        return false
    }

    return startOfLocalDay(job.CompletionDate) > startOfLocalDay(toDoDate)
}

export function getJobDeadlineState(job: JobDeadlineInput): JobDeadlineState {
    if (!job.CompletionDate) {
        return job.Status === JobStatus.Lost ? 'lost' : 'neutral'
    }

    return isCompletedLate(job) ? 'lost' : 'success'
}
